import { render } from "./MenuLateral.vue?vue&type=template&id=293aa907"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=293aa907&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__